/**
 * Icônes tech (SVG) à fond sombre / noir sur transparence : pastille blanche sous l’image pour le contraste sur UI sombre.
 */
const LIGHT_BG_ICON_PATHS = new Set([
    "/images/langages/vercel.svg",
    "/images/tools/cursor.svg",
    "/images/tools/notion.svg",
]);

export function techIconNeedsLightBackground(iconSrc: string): boolean {
    return LIGHT_BG_ICON_PATHS.has(iconSrc);
}
